import BuyToShare from 'Root/App/Dialog/BuyToShare'
import ShareVisibility from 'Root/App/Dialog/Share'
import mixpanelTrack from 'lib/mixpanel-track'

const ShareDialogSwitch = ({
  elementType,
  id,
  isOpen,
  onClose,
  onConfirm,
  subscriptionPlanCode,
  visibility,
  need_registration,
}) => {
  if (isOpen && subscriptionPlanCode === 'essential') {
    mixpanelTrack('Click condivisione da Gratis')
    return <BuyToShare isOpen={isOpen} onClose={onClose} />
  }

  return (
    <ShareVisibility
      id={id}
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      elementType={elementType}
      visibility={visibility}
      need_registration={need_registration}
    />
  )
}

export default ShareDialogSwitch
